export enum Actions {
  EDIT_PAYMENTS_PENDING = 'EDIT_PAYMENTS_PENDING',
  EDIT_PAYMENTS_SUCCESS = 'EDIT_PAYMENTS_SUCCESS',
  EDIT_PAYMENTS_ERROR = 'EDIT_PAYMENTS_ERROR',
}
